const id = {
  nav: {
    home: "Beranda",
    browse: "Jelajahi Pernikahan",
    browseWeddings: "Jelajahi Pernikahan",
    dashboard: "Dasbor",
    messages: "Pesan",
    profile: "Profil",
    login: "Masuk",
    register: "Daftar",
    logout: "Keluar",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "Platform Pengalaman Pernikahan #1",
      title: "Rasakan Pernikahan Tak Terlupakan di Seluruh Dunia",
      subtitle: "WEDVAYA menghubungkan pasangan dengan pelancong yang mencari pengalaman budaya otentik. Jadilah bagian dari momen spesial \u2013 sebagai tuan rumah atau tamu.",
      cta_host: "Mulai sebagai Tuan Rumah",
      cta_guest: "Temukan Pernikahan",
    },
    trust: {
      freeRegistration: "Pendaftaran Gratis",
      securePayment: "Pembayaran Aman",
      gdprCompliant: "Sesuai GDPR",
    },
    stats: {
      weddings: "Pernikahan",
      worldwide: "di seluruh dunia",
      guests: "Tamu",
      matched: "terhubung",
      countries: "Negara",
      represented: "terwakili",
      rating: "Penilaian",
      average: "rata-rata",
    },
    features: {
      title: "Mengapa WEDVAYA?",
      subtitle: "Kami membuat berbagi pengalaman pernikahan yang tak terlupakan menjadi mudah dan aman.",
      secure: {
        title: "Pembayaran Aman",
        desc: "Semua transaksi dilindungi oleh Stripe. Uang Anda aman hingga acara berlangsung.",
      },
      verified: {
        title: "Profil Terverifikasi",
        desc: "Verifikasi identitas opsional untuk kepercayaan tambahan antara tuan rumah dan tamu.",
      },
      global: {
        title: "Acara Global",
        desc: "Dari pernikahan romantis di Tuscany hingga perayaan tradisional di India.",
      },
      contact: {
        title: "Kontak Langsung",
        desc: "Setelah pemesanan, Anda dapat berkomunikasi langsung dengan tuan rumah.",
      },
      gdpr: {
        title: "Sesuai GDPR",
        desc: "Data Anda aman. Kami mematuhi pedoman perlindungan data Eropa secara ketat.",
      },
      instant: {
        title: "Pemesanan Instan",
        desc: "Proses pendaftaran cepat. Anda akan menerima tanggapan dalam 48 jam.",
      },
    },
    howItWorks: {
      title: "Cara Kerjanya",
      subtitle: "Hanya beberapa langkah menuju pengalaman tak terlupakan",
      step1: {
        title: "Temukan Pernikahan",
        desc: "Jelajahi pilihan pernikahan unik kami di seluruh dunia.",
      },
      step2: {
        title: "Kirim Pendaftaran",
        desc: "Perkenalkan diri Anda kepada pasangan dan ceritakan mengapa Anda ingin hadir.",
      },
      step3: {
        title: "Konfirmasi & Pembayaran",
        desc: "Setelah disetujui, bayar secara online dengan aman. Baru setelah itu tempat Anda terjamin.",
      },
      step4: {
        title: "Rayakan",
        desc: "Rasakan pernikahan otentik dan ciptakan kenangan seumur hidup.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "Daftarkan Pernikahan Anda",
        desc: "Buat profil untuk pernikahan Anda dengan semua detail penting.",
      },
      step2: {
        title: "Tinjau Pendaftaran",
        desc: "Lihat profil tamu yang tertarik.",
      },
      step3: {
        title: "Terima Pembayaran",
        desc: "Setelah acara, Anda otomatis menerima 85% dari pendapatan.",
      },
      step4: {
        title: "Rayakan Bersama",
        desc: "Bagikan hari spesial Anda dengan orang-orang dari seluruh dunia.",
      },
    },
    tabs: {
      forGuests: "Untuk Tamu",
      forHosts: "Untuk Tuan Rumah",
    },
    testimonials: {
      title: "Apa Kata Komunitas Kami",
      subtitle: "Pengalaman nyata dari orang nyata",
    },
    featured: {
      title: "Pernikahan Pilihan",
      subtitle: "Temukan perayaan unik di seluruh dunia",
      viewAll: "Lihat Semua",
      perPerson: "per orang",
    },
    cta: {
      title: "Siap untuk Pengalaman Tak Terlupakan?",
      subtitle: "Bergabung dengan komunitas WEDVAYA",
      description: "Apakah Anda ingin berbagi pernikahan Anda dengan dunia atau mencari pengalaman perjalanan unik \u2013 WEDVAYA membuatnya mungkin.",
      button: "Daftar Gratis",
      becomeHost: "Jadi Tuan Rumah Sekarang",
      learnMore: "Pelajari Lebih Lanjut",
    },
    press: {
      title: "Diliput oleh",
    },
  },
  auth: {
    login: {
      title: "Selamat Datang Kembali",
      email: "Email",
      password: "Kata Sandi",
      button: "Masuk",
      noAccount: "Belum punya akun?",
      register: "Daftar sekarang",
      forgotPassword: "Lupa kata sandi?",
    },
    register: {
      title: "Buat Akun",
      name: "Nama Lengkap",
      email: "Email",
      password: "Kata Sandi",
      role: "Saya ingin...",
      roleHost: "Mengadakan pernikahan",
      roleGuest: "Menghadiri pernikahan",
      terms: "Saya menerima Syarat dan Kebijakan Privasi",
      button: "Daftar",
      hasAccount: "Sudah punya akun?",
      login: "Masuk sekarang",
    },
    forgotPassword: {
      title: "Lupa Kata Sandi?",
      description: "Masukkan email Anda dan kami akan mengirim tautan reset",
      submit: "Kirim Tautan Reset",
      sent: "Periksa Email Anda",
      sentDescription: "Jika ada akun dengan email ini, Anda akan menerima tautan reset kata sandi.",
      backToLogin: "Kembali ke Login",
    },
    resetPassword: {
      title: "Reset Kata Sandi",
      description: "Masukkan kata sandi baru Anda",
      newPassword: "Kata Sandi Baru",
      confirmPassword: "Konfirmasi Kata Sandi",
      submit: "Reset Kata Sandi",
      success: "Kata Sandi Direset!",
      successDesc: "Kata sandi Anda berhasil direset. Anda sekarang dapat masuk.",
      goToLogin: "Ke Halaman Login",
      mismatch: "Kata sandi tidak cocok",
      tooShort: "Kata sandi minimal 6 karakter",
    },
    verification: {
      verifying: "Memverifikasi email Anda...",
      pleaseWait: "Mohon tunggu",
      successTitle: "Email Terverifikasi!",
      success: "Email Anda berhasil diverifikasi!",
      errorTitle: "Verifikasi Gagal",
      noToken: "Tidak ada token verifikasi",
      goToLogin: "Ke Halaman Login",
      tryAgain: "Daftar Ulang",
    },
  },
  dashboard: {
    host: {
      title: "Dasbor Tuan Rumah",
      myWeddings: "Pernikahan Saya",
      applications: "Pendaftaran",
      earnings: "Penghasilan",
      messages: "Pesan",
      createWedding: "Buat Pernikahan",
      noWeddings: "Belum ada pernikahan dibuat",
    },
    guest: {
      title: "Dasbor Tamu",
      myApplications: "Pendaftaran Saya",
      browseWeddings: "Jelajahi Pernikahan",
      messages: "Pesan",
      profile: "Profil Saya",
    },
  },
  wedding: {
    search: {
      title: "Temukan Pernikahan",
      location: "Lokasi",
      date: "Tanggal",
      price: "Harga",
      search: "Cari",
      reset: "Reset",
      noResults: "Tidak ada pernikahan ditemukan",
    },
    card: {
      slots: "slot tersedia",
      perGuest: "per tamu",
      apply: "Daftar",
      viewDetails: "Lihat Detail",
    },
    detail: {
      about: "Tentang Pernikahan Ini",
      host: "Tuan Rumah",
      location: "Lokasi",
      date: "Tanggal",
      dresscode: "Kode Berpakaian",
      price: "Harga per Tamu",
      slots: "Slot Tersedia",
      apply: "Daftar Sekarang",
      alreadyApplied: "Sudah Mendaftar",
    },
    create: {
      title: "Buat Pernikahan Baru",
      titleField: "Judul",
      description: "Deskripsi",
      location: "Lokasi",
      country: "Negara",
      date: "Tanggal",
      dresscode: "Kode Berpakaian",
      price: "Harga per Tamu",
      slots: "Jumlah Tamu",
      currency: "Mata Uang",
      submit: "Buat Pernikahan",
    },
  },
  application: {
    status: {
      pending: "Menunggu",
      approved: "Disetujui",
      rejected: "Ditolak",
    },
    payment: {
      pending: "Pembayaran Menunggu",
      paid: "Dibayar",
      pay: "Bayar Sekarang",
    },
    approve: "Setujui",
    reject: "Tolak",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

  messages: {
    title: "Pesan",
    noMessages: "Tidak ada pesan",
    placeholder: "Tulis pesan...",
    send: "Kirim",
  },
  admin: {
    title: "Dasbor Admin",
    stats: {
      users: "Pengguna",
      hosts: "Tuan Rumah",
      guests: "Tamu",
      weddings: "Pernikahan",
      activeWeddings: "Pernikahan Aktif",
      applications: "Pendaftaran",
      revenue: "Total Pendapatan",
      platformEarnings: "Pendapatan Platform",
    },
    tabs: {
      overview: "Ikhtisar",
      users: "Pengguna",
      weddings: "Pernikahan",
      transactions: "Transaksi",
    },
    actions: {
      ban: "Blokir",
      unban: "Buka Blokir",
      feature: "Tampilkan",
      unfeature: "Sembunyikan",
    },
  },
  common: {
    loading: "Memuat...",
    error: "Terjadi kesalahan",
    success: "Berhasil",
    save: "Simpan",
    cancel: "Batal",
    delete: "Hapus",
    edit: "Edit",
    back: "Kembali",
    next: "Selanjutnya",
    language: "Bahasa",
    currency: "Mata Uang",
  },
  footer: {
    about: "Tentang",
    privacy: "Privasi",
    terms: "Ketentuan",
    contact: "Kontak",
    description: "Platform global untuk pengalaman pernikahan yang tak terlupakan.",
    copyright: "\u00a9 2024 WEDVAYA. Hak cipta dilindungi.",
  },
  notifications: {
    title: "Notifikasi",
    empty: "Belum ada notifikasi",
    markAllRead: "Tandai semua sudah dibaca",
  },
  chat: {
    conversations: "Percakapan",
    search: "Cari percakapan...",
    noConversations: "Belum ada percakapan",
    selectConversation: "Pilih percakapan",
    selectConversationDesc: "Pilih percakapan dari daftar untuk mulai mengobrol",
    online: "Online",
    offline: "Offline",
    connecting: "Menghubungkan...",
    noMessages: "Belum ada pesan",
    startConversation: "Mulai percakapan!",
    placeholder: "Ketik pesan...",
    you: "Anda",
  },
  cookies: {
    title: "Kami menggunakan cookie",
    description: "Kami menggunakan cookie untuk meningkatkan pengalaman Anda, menganalisis lalu lintas, dan untuk tujuan pemasaran.",
    acceptAll: "Terima Semua",
    rejectAll: "Tolak Semua",
    customize: "Kustomisasi",
    settingsTitle: "Pengaturan Cookie",
    functional: "Cookie Fungsional",
    functionalDesc: "Penting untuk website berfungsi dengan baik.",
    analytics: "Cookie Analitik",
    analyticsDesc: "Membantu kami memahami bagaimana pengunjung berinteraksi dengan website.",
    marketing: "Cookie Pemasaran",
    marketingDesc: "Digunakan untuk menayangkan iklan yang dipersonalisasi.",
    saveSettings: "Simpan Pengaturan",
  },
};

export default id;
